import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { serviceIcons } from '../data/mock';
import { Wallet, FileText, Calculator, Building2, Users, Globe, Award } from 'lucide-react';

const iconMap = {
  Wallet: Wallet,
  FileText: FileText,
  Calculator: Calculator,
  Building2: Building2,
  Users: Users,
  Globe: Globe,
  Award: Award
};

const ServicesSection = () => {
  const { t } = useLanguage();

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-teal-600 font-semibold text-sm uppercase tracking-wider mb-3">
            Serviços
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            {t.services.title}
          </h2>
          <p className="text-lg text-slate-600">
            {t.services.subtitle}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.services.items.map((service, index) => {
            const IconComponent = iconMap[serviceIcons[index]];
            return (
              <div
                key={service.id}
                className="group relative bg-slate-50 hover:bg-white rounded-2xl p-6 transition-all duration-300 hover:shadow-xl hover:shadow-slate-200/50 hover:-translate-y-1 border border-transparent hover:border-slate-100"
              >
                {/* Icon */}
                <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  {IconComponent && <IconComponent className="w-6 h-6 text-white" />}
                </div>

                {/* Content */}
                <h3 className="text-lg font-semibold text-slate-900 mb-2 group-hover:text-teal-700 transition-colors">
                  {service.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {service.description}
                </p>

                {/* Decorative corner */}
                <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-teal-500/5 to-transparent rounded-tr-2xl rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
